module.exports = __webpack_public_path__ + "static/media/notRecommended.eb972cdd.svg";